/**
 * Created by alex.y on 8/3/2017.
 */
export class LocationSearchRequest {
    public Top: number = 10;
    public Skip: number = 0;
    public Country?: string = "";
    public City?: string = "";
    public Street?: string = "";

    public constructor(obj: Partial<LocationSearchRequest>) {
        Object.assign(this, obj);
    }

}


// WEBPACK FOOTER //
// ./app/objects/requests/locationSearchRequest.ts